import React, { useState, useEffect } from "react";
import SideNavBar from "./components/sideNavBar";
import firebase from "./firebase";
import LoginPage from "./components/Login/Login";
import {
	setLogInDetails,
	setLoginLoading,
} from "./actions/setpersondetailsaction";
import { useDispatch } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";
import DoctorPage from "./components/DoctorPage/DoctorPage";
import AddMedicine from "./components/Pharmacistslist/AddMedicine";
import PharmacistDashboard from "./components/Pharmacistslist/PharmacistDashboard";
import OperationAllotment from "./components/OperationReprot/operationallotment";
import BirthRepotAllotment from "./components/BirthReport/birthreportallotment";
import DeathRepotAllotment from "./components/DeathReport/deathreportallotment";
import CreatePayRoll from "./components/Payroll/createpayroll";
import NursePage from "./components/Nurses/NursePage";
import Admin from "./components/admin";
import AccountPatient from "./components/Accountant/AccountPatient";
// import varcode from "voucher-code-generator";

const App = () => {
	const dispatch = useDispatch();
	// const loginDetails = useSelector((store) => store.loginDetails);
	// console.log(loginDetails);

	useEffect(() => {
		authListener();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [isLoggedIn, setIsLoggedIn] = useState(null);
	const history = useHistory();
	// const loginDetails = useSelector((state) => state.loginDetails);
	// const setOnLogInDetails = useDispatch();
	const authListener = () => {
		firebase.auth().onAuthStateChanged((user) => {
			// console.log(user?.uid);
			if (user) {
				dispatch(setLoginLoading(true));
				console.log("first");
				firebase
					.firestore()
					.collection("claims")
					.doc(user.uid)
					.get()
					.then((snapshot) => {
						// console.log({snap:snapshot.data()})
						const role = snapshot.data().role;
						if (role) {
							setIsLoggedIn(role);
							dispatch(setLogInDetails({ role: role, doctorId: user.uid }));
							dispatch(setLoginLoading(false));

							history.push(
								role === "doctor"
									? "/doctor/dashboard"
									: role === "pharmacists"
									? "/pharmacist/dashboard"
									: role === "nurses"
									? "/nurse/dashboard"
									: role === "admin"
									? "/admin/dashboard"
									: role === "accountant"
									? "/accountant/dashboard"
									: "/receptionist"
							);
						}
					})
					.catch(() => {
						if (user) {
							// console.log("this is the recc", user);
							// setUser(user);
							setIsLoggedIn("receptionist");
							dispatch(setLoginLoading(false));
							history.push("/receptionist");
						}
						dispatch(setLoginLoading(false));
						console.log("No user found");
					});

				//

				// console.log("this is user: ", user.email);
				// else if (user) {
				//   // const loginDetails = { isLoggedIn: "admin" };
				//   this.setState({ isLoggedIn: "admin" });
				//   this.setState({ user });
				//   // this.props.setOnLogInDetails(loginDetails);
				//   // localStorage.removeItem("user");
				// }
				// console.log(user);
			}
		});
	};
	// const vhh = varcode.generate({
	// 	length: 5,
	// 	count: 1,
	// 	charset: "0123456789",
	// });
	// console.log(vhh[0]);
	return (
		<div className="App">
			<Switch>
				<Route path="/doctor">
					<DoctorPage />
				</Route>

				<Route path="/nurse">
					<NursePage />
				</Route>

				<Route path="/receptionist">
					<SideNavBar />
				</Route>
				<Route path="/admin">
					<Admin />
				</Route>
				<Route path="/Addmedicine">
					<AddMedicine />
				</Route>
				<Route path="/birthreport">
					<BirthRepotAllotment />
				</Route>
				<Route path="/deathreport">
					<DeathRepotAllotment />
				</Route>
				<Route path="/operationreport">
					<OperationAllotment />
				</Route>
				<Route path="/payroll">
					<CreatePayRoll />
				</Route>
				<Route path="/pharmacist">
					<PharmacistDashboard />
				</Route>
				<Route path="/accountant">
					<AccountPatient />
				</Route>

				<Route exact path="/">
					<LoginPage />
				</Route>
			</Switch>
		</div>
	);
};

export default App;
